// src/utils/BeckAnksiyete_engine.js

export const calculateBeckAnksiyete = (answers) => {
  let totalScore = 0;

  // 21 maddenin puanlarını topla (Hiç: 0, Hafif: 1, Orta: 2, Ciddi: 3)
  Object.keys(answers || {}).forEach(qId => {
    const val = Number(answers[qId]);
    if (!isNaN(val)) {
      totalScore += val;
    }
  });

  // Kesme Puanı Değerlendirmesi
  let severity = "minimal";
  let summary = "NORMAL / MİNİMAL ANKSİYETE";
  let analysis = "Öğrencinin anksiyete belirtileri normal sınırlar içerisindedir. Günlük yaşamını veya akademik süreçlerini olumsuz etkileyecek düzeyde bir kaygı gözlenmemektedir.";
  let colorCode = "green";
  let masterRisk = "low";
  let isCritical = false;

  if (totalScore >= 26) {
    severity = "severe";
    summary = "ŞİDDETLİ ANKSİYETE";
    analysis = "Öğrenci yüksek düzeyde bedensel ve zihinsel kaygı belirtileri yaşamaktadır. Bu durum akademik başarısını, sosyal ilişkilerini ve günlük yaşam kalitesini ciddi düzeyde olumsuz etkileyebilir. Bir ruh sağlığı uzmanı (Çocuk ve Ergen Psikiyatristi) ile iş birliği yapılması ve psikolojik destek süreci başlatılması önerilir.";
    colorCode = "red";
    masterRisk = "high";
    isCritical = true; // Şiddetli seviyede kriz alarmı tetikle
  } else if (totalScore >= 16) {
    severity = "moderate";
    summary = "ORTA DÜZEYDE ANKSİYETE";
    analysis = "Öğrenci belirgin kaygı ve huzursuzluk belirtileri göstermektedir. Kaygının kaynaklarını (sınav, aile, sosyal ilişkiler vb.) belirlemeye yönelik bireysel görüşmeler yapılması ve stres yönetimi/gevşeme tekniklerinin kazandırılması faydalı olacaktır.";
    colorCode = "amber";
    masterRisk = "medium";
  } else if (totalScore >= 8) {
    severity = "mild";
    summary = "HAFİF DÜZEYDE ANKSİYETE";
    analysis = "Öğrenci hafif düzeyde anksiyete belirtileri taşımaktadır. Dönemsel stres faktörleri takip edilmeli, öğrenciye duygu düzenleme ve nefes egzersizleri gibi destekleyici rehberlik sunulmalıdır.";
    colorCode = "blue";
    masterRisk = "low";
  }

  const risks = [];
  if (totalScore >= 16) {
    risks.push({
      text: `Yüksek Beck Anksiyete Skoru (${totalScore} Puan - ${summary})`,
      severity: totalScore >= 26 ? "critical" : "high"
    });
  }

  return {
    // 1. Ortak Dil Zarfı (App.js ve StudentFolders için)
    riskScore: Math.round((totalScore / 63) * 100),
    masterRisk: masterRisk,
    isCritical: isCritical,
    domain: "clinical", // Klinik tarama odaklı test

    // 2. Rapor Detay Verileri
    totalScore: totalScore,
    severity: severity,
    summary: summary,
    analysis: analysis,
    colorCode: colorCode,
    risks: risks,
    chartData: [
      { subject: "Anksiyete Skoru", A: totalScore, rawCount: totalScore, fullMark: 63 }
    ]
  };
};